module.exports = __webpack_public_path__ + "img/atlaslist1img1.bf444708.jpg";